export interface BaseJobCardNavProps {
  isPreview: boolean;
  showKeyboardHints: boolean;
  showApplyButton: boolean;
  onApply: () => void;
  onSave: () => void;
  onNext: () => void;
}

export interface JobDeckNavProps extends BaseJobCardNavProps {
  onPrevious: () => void;
  showPrevArrow: boolean;
  isSaved: boolean;
  isApplied: boolean;
}

// no I don't know what is going on here either
export type JobCardNavProps = BaseJobCardNavProps | JobDeckNavProps;

export enum ArrowDirection {
  Right = "right",
  Left = "left",
}
